import i18next, { type i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { Locale } from '../locale';
import { bg } from './resources/bg';
import { en } from './resources/en';

export const defaultNS = 'translation';

export const resources = {
  en: { translation: en },
  bg: { translation: bg },
} as const;

/** Creates and synchronously initialises an i18next instance (resources are bundled). */
export function createI18n(locale: Locale): i18n {
  const instance = i18next.createInstance();
  void instance.use(initReactI18next).init({
    lng: locale,
    fallbackLng: 'en',
    supportedLngs: ['en', 'bg'],
    defaultNS,
    resources,
    initAsync: false,
    interpolation: { escapeValue: false }, // React already escapes.
    returnNull: false,
  });
  return instance;
}
